export default "__VITE_ASSET__OWkkS$J_bktHla5g5Zqn4A__"